import {useQuery} from '@tanstack/react-query';
import {getCompany} from '../operations/get-company';
import {usePressReleaseQuery} from './use-press-release-query';

export const useCompanyQuery = () => {
  const pressReleaseQuery = usePressReleaseQuery();
  const companyId = pressReleaseQuery.data?.companyId;

  const query = useQuery({
    queryKey: ['company', companyId],
    async queryFn() {
      if (companyId === undefined) return null;

      return getCompany({companyId});
    },
    enabled: pressReleaseQuery.isSuccess,
  });

  return query;
};
